import * as React from "react"

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "secondary" | "outline";
}

export function Badge({ className = "", variant = "default", ...props }: BadgeProps) {
  const variantStyles = {
    default: "bg-foreground text-background",
    secondary: "bg-secondary text-secondary-foreground",
    outline: "border border-border bg-transparent text-foreground",
  };

  return (
    <div
      className={`inline-flex items-center rounded-full px-2 py-px text-xs font-semibold transition-colors ${variantStyles[variant]} ${className}`}
      {...props}
    />
  );
}
